import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { getGraphqlUrl } from '../utils';

/* -------------------------------------------------------------------------- *
 * apolloService
 *
 * The raw Apollo Client, which is passed to ApolloProvider and can also be
 * used imperatively. See https://www.apollographql.com/docs/react/.
 * -------------------------------------------------------------------------- */

const cache = new InMemoryCache();
const link = createHttpLink( { uri: getGraphqlUrl() } );

export const apolloService = new ApolloClient( { cache, link } );
